export default __webpack_public_path__ + "static/media/total.789b408d.svg";